export class ConditionClass{
    field:string;
    condition:string;
    value:string;
}